// Permanent fallback demo data — used when there's no location.state, no
// stashed payload from the dispatch board, and no random demo loaded
// (i.e. anyone hitting /driver-demo cold, especially in production).
//
// To update the canonical demo: open the demo from the dispatch board's
// 📱 button on a run you like, copy the `driverDemoPayload` value from
// your browser's localStorage, and paste it in below.

const SAMPLE_RUN = {
  driver: {
    id: 2,
    name: 'Driver 2',
    isLocalDriver: false,
    notes: 'Run in this order please. | Heads up — heavy bank tonight, expect tight turns.',
    flights: [
      {
        uniqueId: 'sample-1',
        flightNumber: 'WN 1861',
        destination: 'EUG',
        gate: 'C37',
        etd: '20:15',
        bags: 7,
        registration: 'N8821S',
        binDistribution: { C: 4, D: 3 },
        connectionCategory: 'hot',
        connectionTime: 29,
        runOrder: 1,
        isOvernight: false,
        notes: 'Watch for busted bag from upline station on that hot connection.',
      },
      {
        uniqueId: 'sample-2',
        flightNumber: 'WN 1796',
        destination: 'BOI',
        gate: 'C49',
        etd: '20:20',
        bags: 4,
        registration: 'N7826B',
        binDistribution: { B: 2, C: 2 },
        connectionCategory: 'normal',
        connectionTime: 34,
        runOrder: 2,
        isOvernight: false,
      },
      {
        uniqueId: 'sample-3',
        flightNumber: 'WN 2085',
        destination: 'SLC',
        gate: 'C43',
        etd: '20:20',
        bags: 2,
        registration: 'N8956W',
        binDistribution: { B: 1, C: 1 },
        connectionCategory: 'normal',
        connectionTime: 34,
        runOrder: 3,
        isOvernight: false,
      },
      {
        uniqueId: 'sample-4',
        flightNumber: 'WN 3112',
        destination: 'ELP',
        gate: 'C59',
        etd: '20:32',
        bags: 3,
        registration: 'N8645B',
        binDistribution: { D: 2, A: 1 },
        connectionCategory: 'normal',
        connectionTime: 46,
        runOrder: 4,
        isOvernight: false,
      },
      {
        uniqueId: 'sample-5',
        flightNumber: 'WN 2068',
        destination: 'SEA',
        gate: 'C41',
        etd: '20:38',
        bags: 1,
        // Same tail as the inbound — tail-to-tail bag transfer
        registration: 'N259WN',
        binDistribution: { D: 1 },
        connectionCategory: 'normal',
        connectionTime: 52,
        isThruBag: true,
        runOrder: 5,
        isOvernight: false,
      },
      {
        uniqueId: 'sample-6',
        flightNumber: 'WN 1384',
        destination: 'COS',
        gate: 'C40',
        etd: '23:55',
        bags: 1,
        registration: 'N8567Z',
        binDistribution: { C: 1 },
        connectionCategory: 'cold',
        connectionTime: 249,
        runOrder: 6,
        isOvernight: false,
      },
    ],
  },
  inboundETA: '19:46',
  inboundGate: 'C60',
  inboundFlightNumber: '1139',
  inboundFrom: 'MCO',
  inboundRegistry: 'N259WN',
  otherDriverCount: 2,
  savedAt: 0,
};

export default SAMPLE_RUN;
